import type { FC } from "react";

import { ManualDasConfigurationSearchForm } from "src/app/features/ManualDasConfiguration/components/forms/ManualDasConfigurationSearchForm";
import { ManualDasConfigurationsTable } from "src/app/features/ManualDasConfiguration/components/tables/ManualDasConfigurationTable";
import type { ManualDasConfigurationEntity } from "src/app/features/ManualDasConfiguration/types/ManualDasConfigurationEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const ManualDasConfigurationsPage: FC<NoneOwnProps> = () => {
    const table = <ManualDasConfigurationsTable />;
    const searchForm = <ManualDasConfigurationSearchForm />;
    const hasAccess = canAccess(ResourceName.MANUAL_DAS_CONFIGURATION, "canRead");

    return (
        <PageLayout name="manualDasConfigurations_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.manualDasConfigurations" />
                    <ResourceManager<ManualDasConfigurationEntity>
                        useDataGroup
                        dataMapperKey="manualDasConfigurationsTableData"
                        resource={ResourceName.MANUAL_DAS_CONFIGURATION}
                        table={table}
                        searchForm={searchForm}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
